import classNames from 'classnames'
import type { SegmentedControlProps } from './segmented-control.interface'
import classes from './segmented-control.module.scss'

export function SegmentedControl<T extends string>({
  options,
  value,
  onChange,
  ariaLabel,
  className,
}: SegmentedControlProps<T>) {
  return (
    <div role="group" aria-label={ariaLabel} className={classNames(classes.root, className)}>
      {options.map((option) => {
        const isSelected = option.value === value
        return (
          <button
            key={option.value}
            type="button"
            aria-pressed={isSelected}
            className={classNames(classes.option, { [classes.selected]: isSelected })}
            onClick={() => onChange(option.value)}
          >
            {option.label}
            {option.count !== undefined && <span className={classes.count}>{option.count}</span>}
          </button>
        )
      })}
    </div>
  )
}
